const MenuTitle = ({text, iconSrc, className, ...restProps}) =>
  <>
    {iconSrc && <img src={iconSrc} alt={text} />}
    <h3 className={`mt-3 mb-2 text-green text-18 font-weight-600 ${className || ''}`} {...restProps}>{text}</h3>
  </>

export default MenuTitle
